import React from 'react';
import { TextInput, NumberInput, required, useTranslate } from 'react-admin';
import { FieldPair, FormSection } from '@/components/shell';

/** The fields of a cost center, shared by its create and edit pages. */
export const CostCenterFields: React.FC = () => {
  const t = useTranslate();
  return (
    <FormSection title={t('screens.costCenters.sectionDetails')}>
      <FieldPair>
        <TextInput source="name" label={t('resources.cost-centers.fields.name')} validate={required()} fullWidth />
        <NumberInput
          source="unpaidCreditLimit"
          label={t('resources.cost-centers.fields.unpaidCreditLimit')}
          min={0}
          fullWidth
          helperText={t('screens.costCenters.unpaidLimitHint')}
        />
      </FieldPair>
      <TextInput
        source="description"
        label={t('resources.cost-centers.fields.description')}
        fullWidth
        multiline
        rows={3}
      />
    </FormSection>
  );
};
